import { render } from "./Create.vue?vue&type=template&id=40ffa172&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=40ffa172&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-40ffa172"

export default script